import React from "react";
import cn from "classnames";

import styles from "./styles.module.scss";

const Title = ({ withMargin, children }) => {
    return (
        <h3
            className={cn(styles.title, {
                [styles["title--with-margin"]]: withMargin,
            })}
        >
            {children}
        </h3>
    );
};

export default Title;
